import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import StyledModal from "components/Modal";

import { ReactComponent as SuccessCheck } from "assets/images/success-check.svg";
import { ReactComponent as ErrorModal } from "assets/images/error-modal.svg";

export enum MonobankResultType {
  SUCCESS = "success",
  ERROR = "error",
}

interface MonobankResultModalProps {
  type: MonobankResultType;
  isOpen: boolean;
  onClose: () => void;
}

const MonobankResultModal: React.FC<MonobankResultModalProps> = (props) => {
  const { type, isOpen, onClose } = props;

  const renderContent = () => {
    switch (type) {
      case MonobankResultType.SUCCESS:
        return (
          <>
            <SuccessCheck />
            <Typography variant="h5" sx={{ mt: 3 }}>
              Monobank успішно підключений.
            </Typography>
            <Typography color="grey700" sx={{ mt: 0.5 }}>
              Ви можете вимкнути інтеграцію в будь-який момент.
            </Typography>
          </>
        );
      case MonobankResultType.ERROR:
        return (
          <>
            <ErrorModal />
            <Typography variant="h5" sx={{ mt: 3 }}>
              На жаль, щось пішло не так.
            </Typography>
            <Typography color="grey700" sx={{ mt: 0.5 }}>
              Якщо проблема не зникає, зверніться до служби підтримки.
            </Typography>
          </>
        );
    }
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onClose}
      content={<Box sx={{ textAlign: "center" }}>{renderContent()}</Box>}
      closeBtnProps={{ sx: { width: "100%" } }}
      closeBtnText={
        type === MonobankResultType.ERROR ? "Спробуйте ще раз" : "Ок"
      }
    />
  );
};

export default MonobankResultModal;
